import { CHANGE_MEDIA, LOGOUT_REQUEST } from "../../constants/actionTypes";

const getInitialMediaState = () => {
  if (typeof window === "undefined") {
    return { mobile: false, tablet: false };
  }
  return {
    mobile: window.matchMedia("(max-width: 767px)").matches,
    tablet: window.matchMedia("(max-width: 1024px)").matches,
  };
};

const INITIAL_STATE = getInitialMediaState();

const mediaReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHANGE_MEDIA:
      return action.media;
    case LOGOUT_REQUEST:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default mediaReducer;
